import { render, staticRenderFns } from "./DocumentsActivity.vue?vue&type=template&id=b75e6898&scoped=true"
import script from "./DocumentsActivity.vue?vue&type=script&lang=js"
export * from "./DocumentsActivity.vue?vue&type=script&lang=js"
import style0 from "./DocumentsActivity.vue?vue&type=style&index=0&id=b75e6898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75e6898",
  null
  
)

export default component.exports